import VIDEO_RECIPES from '../../../../../shared/video_recipes.json';

/**
 * A recipe's dashboard title and description.
 *
 * They live in `shared/video_recipes.json`, outside the frontend, so the backend
 * reads the same copy when it lists recipes over the API.
 */
export type RecipeName = keyof typeof VIDEO_RECIPES;

export function recipeCopy(name: RecipeName): { title: string; description: string } {
    return VIDEO_RECIPES[name];
}
